module.exports = __webpack_public_path__ + "static/media/1017754.3da93b80.png";